module.exports = __webpack_public_path__ + "img/sophia-05.d71596ad.png";